import { ButtonIcon } from './ButtonIcon';

// TODO: in v9, move styled() from ButtonIcon.jsx to here
export var StyledButtonIcon = ButtonIcon;